import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, GiftIcon } from './Icons';
export const OfferSection = () => {
  const items = [{
    title: 'Ebook Principal',
    description: 'Tu hoja de ruta para reprogramar tu metabolismo',
    value: '197€'
  }, {
    title: 'Bono 1: Guía de Suplementos Bio-idénticos',
    description: 'Qué tomar para sofocos, lívido y densidad ósea',
    value: '97€'
  }, {
    title: 'Bono 2: Manual El Santuario del Sueño',
    description: 'Guía táctica para eliminar el insomnio de las 3 AM',
    value: '47€'
  }, {
    title: 'Bono 3: El Recetario de 15 Minutos',
    description: 'Comidas rápidas que no disparan la insulina',
    value: '47€'
  }, {
    title: 'Bono 4: Plan 7 Días Desinflamación Express',
    description: 'El reset rápido para volver a sentirte tú',
    value: '37€'
  }];
  return <section id="bonuses" className="py-8 px-4 md:px-8 bg-white" data-id="element-160">
      <div className="max-w-5xl mx-auto" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-162">
          <h2 className="text-sm font-bold text-brand-gold uppercase tracking-widest mb-2" data-id="element-163">
            Presentamos
          </h2>
          <h3 className="text-4xl md:text-5xl font-serif font-bold text-brand-green mb-4" data-id="element-164">
            PAZ HORMONAL +40
          </h3>
          <p className="text-xl text-brand-charcoal/80 font-serif italic" data-id="element-165">
            El sistema completo que te guía de la mano por tu transición
            hormonal.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-166">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="order-2 lg:order-1 lg:sticky lg:top-24" data-id="element-167">
            <img src="https://cdn.magicpatterns.com/uploads/dpFyDM2gcDHWgCcZXkixzj/Imagen_Producto.webp" alt="Paz Hormonal +40 Bundle" loading="lazy" decoding="async" className="w-full max-w-md mx-auto drop-shadow-xl" data-id="element-168" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="order-1 lg:order-2 bg-brand-cream p-6 md:p-8 rounded-3xl shadow-sm border border-brand-gold/20" data-id="element-169">
            <h4 className="text-2xl font-serif font-bold text-brand-charcoal mb-6 border-b border-brand-gold/30 pb-4" data-id="element-170">
              Lo que obtienes hoy:
            </h4>

            <ul className="space-y-3 mb-6" data-id="element-171">
              {items.map((item, index) => <li key={index} className="flex items-start gap-3 py-2 border-b border-brand-creamAlt/80 last:border-0" data-id="element-172">
                  <div className="mt-1 bg-brand-green/10 p-1 rounded-full text-brand-green flex-shrink-0" data-id="element-173">
                    <CheckIcon className="w-4 h-4" data-id="element-174" />
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-175">
                    <div className="flex items-baseline justify-between gap-2" data-id="element-176">
                      <span className="text-brand-charcoal font-semibold text-sm md:text-base" data-id="element-177">
                        {item.title}
                      </span>
                      <span className="text-sm font-bold text-brand-green whitespace-nowrap" data-id="element-178">
                        {item.value}
                      </span>
                    </div>
                    <p className="text-xs md:text-sm text-brand-charcoal/60 mt-0.5" data-id="element-179">
                      {item.description}
                    </p>
                  </div>
                </li>)}
            </ul>

            <div className="mb-8 flex items-start gap-4 bg-brand-green p-5 md:p-6 rounded-2xl shadow-md text-white" data-id="element-180">
              <div className="flex-shrink-0 bg-brand-gold/20 p-2.5 rounded-xl text-brand-gold" data-id="element-181">
                <GiftIcon className="w-7 h-7" data-id="element-182" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-183">
                <p className="font-serif font-bold leading-tight" data-id="element-184">
                  <span className="text-3xl md:text-4xl text-brand-gold" data-id="element-185">
                    +11
                  </span>{' '}
                  <span className="text-lg md:text-xl" data-id="element-186">
                    Recursos Exclusivos incluidos como sorpresa
                  </span>
                </p>
                <p className="text-sm md:text-base text-white/80 mt-2 leading-relaxed" data-id="element-187">
                  Protocolos, guías y checklists para mujeres 40+
                </p>
              </div>
            </div>

            <div className="bg-white p-6 rounded-2xl text-center border-2 border-brand-gold/40 shadow-sm space-y-3" data-id="element-188">
              <p className="text-sm font-semibold text-brand-charcoal/70" data-id="element-189">
                Valor total del paquete:{' '}
                <span className="text-brand-crimson line-through decoration-2" data-id="element-190">
                  425€
                </span>
              </p>
              <p className="text-2xl md:text-3xl font-serif font-bold text-brand-green leading-snug" data-id="element-191">
                Todo incluido hoy por solo{' '}
                <span className="text-brand-green" data-id="element-192">27€</span>
              </p>
              <p className="text-xs md:text-sm text-brand-charcoal/60 uppercase tracking-widest" data-id="element-193">
                Un pago único. Acceso de por vida.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};